import { useTranslation } from 'react-i18next';
import { useTheme } from '../../theme';
import { SearchToolbar } from '../SearchToolbar';

export interface UsersFilterProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder?: string;
  searchAriaLabel?: string;
  filterLabel?: string;
  filterAriaLabel?: string;
  onAddUser?: () => void;
  addUserLabel?: string;
  addUserAriaLabel?: string;
  /** Identificador de teste para o input de busca */
  dataE2eSearchInput?: string;
  /** Identificador de teste para o botão de adicionar usuário */
  dataE2eAddButton?: string;
}

export function UsersFilter({
  searchValue,
  onSearchChange,
  searchPlaceholder,
  searchAriaLabel,
  filterLabel: _filterLabel,
  filterAriaLabel: _filterAriaLabel,
  onAddUser,
  addUserLabel,
  addUserAriaLabel,
  dataE2eSearchInput,
  dataE2eAddButton,
}: UsersFilterProps) {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <SearchToolbar
      searchValue={searchValue}
      onSearchChange={onSearchChange}
      searchPlaceholder={
        searchPlaceholder ?? t('user_management.search_placeholder')
      }
      searchAriaLabel={searchAriaLabel ?? t('user_management.search_aria')}
      actionButton={
        onAddUser
          ? {
              label: addUserLabel ?? t('user_management.add_user'),
              onClick: onAddUser,
              ariaLabel: addUserAriaLabel ?? t('user_management.add_user'),
              textColor: theme.palette.addUser.text,
              backgroundColor: theme.palette.addUser.background,
            }
          : undefined
      }
      classNamePrefix="user-mgmt"
      dataE2eSearchInput={dataE2eSearchInput}
      dataE2eActionButton={dataE2eAddButton}
    />
  );
}
